import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
interface SparkleDecorationProps {
  className?: string;
  color?: string;
  size?: number;
  type?: 'star' | 'sparkle';
  animated?: boolean;
  delay?: number;
}
export function SparkleDecoration({
  className = '',
  color = '#E8735A',
  size = 24,
  type = 'sparkle',
  animated = true,
  delay = 0
}: SparkleDecorationProps) {
  // Generate random values once per mount so each particle is unique
  const motion_params = useMemo(() => {
    const randomDelay = delay || Math.random() * 4;
    const duration = 6 + Math.random() * 6;
    // Random drift distances for the floating dust effect
    const driftX = (Math.random() - 0.5) * 40;
    const driftY = (Math.random() - 0.5) * 30;
    const driftX2 = (Math.random() - 0.5) * 35;
    const driftY2 = (Math.random() - 0.5) * 25;
    return {
      animate: {
        x: [0, driftX, driftX2, -driftX * 0.6, 0],
        y: [0, driftY, -driftY2, driftY * 0.7, 0],
        opacity: [0.2, 0.8, 0.4, 1, 0.2],
        scale: [0.7, 1.1, 0.85, 1.2, 0.7],
        rotate: [0, 30, -20, 45, 0]
      },
      transition: {
        duration,
        repeat: Infinity,
        ease: 'easeInOut' as const,
        delay: randomDelay
      }
    };
  }, [delay]);
  const animProps = animated ? motion_params : {};
  if (type === 'star') {
    return <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...animProps} data-id="element-406">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" fill={color} data-id="element-407" />
      </motion.svg>;
  }
  return <motion.svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...animProps} data-id="element-408">
      <path d="M12 2C12 2 12 10 20 12C12 14 12 22 12 22C12 22 12 14 4 12C12 10 12 2 12 2Z" fill={color} data-id="element-409" />
      <circle cx="19" cy="5" r="2" fill={color} data-id="element-410" />
      <circle cx="5" cy="19" r="1.5" fill={color} data-id="element-411" />
    </motion.svg>;
}